<template>
    <div :class="{ 'menu-item-7981__container': item.id == 7981 }" class="relative group">
        <a
            ref="top"
            @focus="handleFocus"
            :class="item.class"
            class="relative block z-50 px-1.5 py-3 font-semibold tracking-tight transition duration-200 focus:text-white hover:bg-brand focus:bg-brand hover:text-white"
            :href="item.url"
            >{{ item.name }}</a
        >
        <ul
            ref="dropdown"
            class="absolute z-10 hidden bg-white border shadow group-hover:grid top-full custom-dropdown-menu whitespace-nowrap"
            style="max-width: 500px;"
            :class="index > 5 ? 'right-0' : 'left-0'"
        >
            <li v-for="child in item.children" :key="child.id">
                <a
                    v-html="child.name"
                    class="block p-2 font-semibold transition duration-200 hover:bg-brand hover:text-white focus:bg-brand focus:text-white"
                    :href="child.url"
                ></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['item', 'index'],
    methods: {
        listenForEscape() {
            const dropdown = this.$refs.dropdown;
            if (event.keyCode == 27) {
                dropdown.classList.add('hidden');

                document.removeEventListener('keydown', this.listenForEscape);
            }
        },
        listenForTab() {
            const dropdown = this.$refs.dropdown;
            const dropdownItems = [...dropdown.querySelectorAll('a')];

            if (event.keyCode == 9) {
                if (document.activeElement == dropdownItems[dropdownItems.length - 1]) {
                    dropdown.classList.add('hidden');
                    document.removeEventListener('keydown', this.listenForTab);
                }
            }
            if (event.shiftKey && event.keyCode == 9) {
                if (document.activeElement == this.$refs.top) {
                    dropdown.classList.add('hidden');
                    document.removeEventListener('keydown', this.listenForTab);
                }
            }
        },
        openDropdown() {
            const dropdown = this.$refs.dropdown;
            dropdown.classList.remove('hidden');
            dropdown.classList.add('grid');
        },
        handleFocus() {
            this.openDropdown();
            document.addEventListener('keydown', this.listenForEscape);
            document.addEventListener('keydown', this.listenForTab);
        }
    }
};
</script>

<style lang="scss">
.menu-item-7981__container .custom-dropdown-menu {
    @apply right-0 grid-cols-5 left-auto;
    width: 768px;
    max-width: none !important;

    a {
        @apply flex;
    }

    img {
        @apply w-5 mr-1.5;
    }
}
</style>
